import { authenticatedPost } from '../../../../../api/request';

export default async function saveLanguageInProfile(idLanguage, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error agregando el lenguaje a su perfil.');
    const url = `/doctor-profile/language/${idLanguage}`;
    return await authenticatedPost(url, onFail);
}
